import React from 'react';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Align from '@marvelapp/marvel-ui/align';

import Image from 'marketing-website/components/modules/Image';
import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';

import assets from 'marketing-website/configs/pages/features/collaboration/assets';
import styles from './style/general.module.css';

export default function HubBlock() {
  return (
    <Spacing size="xl" type="padding" position="top">
      <PageWrap size="m">
        <Spacing size="xl" type="padding" position="top">
          <Spacing size="l" sizeM="0" type="bottom" position="top">
            <HeadingBlock
              maxWidth={400}
              size="xs"
              justifyContent="center"
              justifyM="start"
              title="Cross-company collaboration "
              copy={
                <span>
                  Keep everyone up to date using the features that make Marvel
                  the perfect collaborative design platform.
                  <br />
                  <br />
                  Add collaborators to projects, assign user roles and leave
                  feedback through comments and annotations.
                </span>
              }
            />
          </Spacing>
        </Spacing>
      </PageWrap>
      <div className={styles.background}>
        <Align type="center">
          <Image {...assets.hub} hasShadow={false} maxWidth={1440} block />
        </Align>
      </div>
    </Spacing>
  );
}



// WEBPACK FOOTER //
// ./src/pages/features/collaboration/HubBlock.js